import type { ReactNode } from "react";

export function SurveyStatusMainText({ children }: { children: string }) {
    return <h1 className="text-2xl mb-1 text-center">{children}</h1>;
}

export function SurveyStatusSubText({ children }: { children: string }) {
    return <p className="text-center">{children}</p>;
}

export default function SurveyStatus({ children }: { children: ReactNode }) {
    return <div className="flex flex-col items-center justify-center min-h-100">{children}</div>;
}
